import { render, staticRenderFns } from "./index.vue?vue&type=template&id=766c3b0c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=766c3b0c&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=766c3b0c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c3b0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766c3b0c')) {
      api.createRecord('766c3b0c', component.options)
    } else {
      api.reload('766c3b0c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=766c3b0c&scoped=true", function () {
      api.rerender('766c3b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/input/IkTableDataPopup/index.vue"
export default component.exports